module.exports = __webpack_public_path__ + "static/media/avatar-default.d48a8973.png";